<template>
  <b-card no-body  v-bind:class="{ spinner: isLoading }">
    <template v-slot:header>
      <b-row class="mx-1">
        <b-col >
          <!-- survey filter -->
          <treeselect
            class="my-2"
            v-model="filter.survey"
            valueFormat="object"
            :auto-load-root-options="false"
            :placeholder="$t('Webportal.SurveyFilter.Placeholder')"
            :options="treeselect.structureItems"
            :disableFuzzyMatching="true"
            :showCount="true"
            :disable-branch-nodes="true"
            @input="loadFilterData()"
          />
        </b-col>
        <b-col>
          <!-- Scenario Filter -->
          <treeselect
            class="my-2"
            v-model="filter.scenario"
            :placeholder="$t('Webportal.ScenarioFilter.Placeholder')"
            :options="treeselect.scenario"
            :multiple="true"
            :disable-branch-nodes="true"
            :limit="2"
            :disabled="!filter.survey"
          />
        </b-col>
      </b-row>
      <b-row class="mx-1">
        <b-col>
          <!-- Wave Filter -->
          <treeselect
            class="my-2"
            v-model="filter.wave"
            :placeholder="$t('Webportal.WaveFilter.Placeholder')"
            :options="treeselect.wave"
            :multiple="true"
            :disable-branch-nodes="true"
            :limit="2"
            :disabled="!filter.survey"
          />
        </b-col>
        <b-col>
          <!-- CustomProps Filter -->
          <treeselect
            class="my-2"
            v-model="filter.customProp"
            :placeholder="$t('Webportal.PropertyValueFilter.Placeholder')"
            :options="treeselect.customProp"
            :multiple="true"
            :disable-branch-nodes="true"
            :limit="2"
            :disabled="!filter.survey"
          />
        </b-col>
      </b-row>
      <b-row class="mx-1">
        <b-col cols="2">
          <b-form-input
            style="width:150px ;"
            class="my-2"
            v-model="filter.statusFrom"
            :placeholder="$t('Webportal.VwTap.StatusFrom')"
            type="number"
            min="0"
            max="400"
            :disabled="!filter.survey"
          ></b-form-input>
        </b-col>
        <b-col cols="2">
          <b-form-input
          style="width:150px ;"
            class="my-2"
            v-model="filter.statusTo"
            :placeholder="$t('Webportal.VwTap.StatusTo')"
            type="number"
            min="0"
            max="400"
            :disabled="!filter.survey"
          ></b-form-input>
        </b-col>
        <b-col cols="2">
          <b><b-form-checkbox style="height:38px;margin: 0.5rem;"  v-model="filter.getNet" name="check-button" switch>Brutto/Netto</b-form-checkbox></b>
        </b-col>
        <b-col cols="2">
          <b><b-form-checkbox style="height:38px;margin: 0.5rem;"  v-model="filter.premiumToVolumen" name="check-button" switch>PremiumToVolumen</b-form-checkbox></b>
        </b-col>
        <b-col cols="4">
          <b-row style="justify-content: end;">
            <b-button style="height: 38px; margin: 0.5rem;" @click="loadRowData()" :disabled="!filter.survey">{{$t('Webportal.VwTap.Refresh')}}</b-button>
            <b-button style="height: 38px; margin: 0.5rem; display: block;" @click="swapGrid()">
              <font-awesome-icon icon="level-up" style="transform:rotate(90deg)"/>
              <a v-if="displayGrid === 'grouped'">{{$t('Webportal.VwTap.SingleCheckView')}}</a>
              <a v-else>{{$t('Webportal.VwTap.GroupedView')}}</a>
            </b-button>
            <b-button style="height: 38px; margin: 0.5rem;" variant="success" size="sm" @click="openExportPopup()" :disabled="!filter.survey">
              <font-awesome-icon icon="file-excel" />
            </b-button>
          </b-row>
        </b-col>
      </b-row>
    </template>
    <b-card-body class="p-0">
      <VwTapGrid
        v-show="displayGrid === 'grouped'"
        :ColumnDefs="grouped.columnDefs"
        :RowData="grouped.rowData"
        :SideBar="grouped.sideBar"
        :MasterDetail="grouped.masterDetail"
        :DetailCellRendererParams="grouped.detailCellRendererParams"
        :ShowLoadingOverlay="grouped.showLoadingOverlay"
        Level="grouped"
      >
      </VwTapGrid>
      <VwTapGrid
        v-show="displayGrid === 'single'"
        :ColumnDefs="singleCheck.columnDefs"
        :RowData="singleCheck.rowData"
        :SideBar="singleCheck.sideBar"
        :MasterDetail="singleCheck.masterDetail"
        :DetailCellRendererParams="singleCheck.detailCellRendererParams"
        :ShowLoadingOverlay="singleCheck.showLoadingOverlay"
        Level="single"
        :RowClassRules="singleCheck.rowClassRules"
      >
      </VwTapGrid>
      <!-- ag grid solely to produce export-->
      <ag-grid-vue
        class="ag-theme-alpine"
        style="display: none; width: 100%; height: 76vh"
        :columnDefs="exportGrid.columnDefs"
        :suppressPropertyNamesCheck="true"
        :rowData="exportGrid.rowData"
        :masterDetail="true"
        :detailCellRendererParams="exportGrid.detailCellRendererParams"
        @grid-ready="onExportGridReady"
      >
      </ag-grid-vue>
    </b-card-body>
    <ExportPopup v-if="showExportPopup" @close="closeExportPopup()">
      <b-col>
        <b-row style="justify-content: center;">
          <label for="historical-data-select">Altdaten von: </label>
          <select id="historical-data-select" v-model="filter.reportType">
            <option :value="null" :selected="true">keine</option>
            <option :value="0">Premium</option>
            <option :value="1">LNF</option>
            <option :value="2">Volumen</option>
          </select>
        </b-row>
        <b-row>
          <b-button style="height: 38px; margin: 0.5rem;" variant="success" size="sm" @click="exportExcelFsReport()">
            <font-awesome-icon icon="file-excel" /> FS Report
          </b-button>
          <b-button style="height: 38px; margin: 0.5rem;" variant="success" size="sm" @click="exportExcelReport()">
            <font-awesome-icon icon="file-excel" /> Report
          </b-button>
          <b-button style="height: 38px; margin: 0.5rem;" variant="success" size="sm" @click="exportExcelFile()">
            <font-awesome-icon icon="file-excel" /> {{$t('Webportal.VwTap.RawDataQA')}}
          </b-button>
          <b-button style="height: 38px; margin: 0.5rem;" variant="success" size="sm" @click="exportExcelRawData()">
            <font-awesome-icon icon="file-excel" /> {{$t('Webportal.VwTap.RawDataClient')}}
          </b-button>
          <b-button style="height: 38px; margin: 0.5rem;" variant="secondary" size="sm" @click="closeExportPopup()">
            {{$t('Webportal.Cancel')}}
          </b-button>
        </b-row>
      </b-col>
    </ExportPopup>
  </b-card>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import 'ag-grid-enterprise';
import SurveysService from '@/services/SurveysService';
import VwTapService from "../../services/VwTapService";
import CurrencyCellRenderer from './CellRenderer/CurrencyCellRenderer';
import PercentageCellRenderer from './CellRenderer/PercentageCellRenderer';
import ExportPopup from './ExportPopup.vue';
import DetailColumnToolPanel from './DetailColumnToolPanel';
import EventBus from '@/services/EventBus.js'
import IncludeRegardlessOfValuesCellRenderer from './CellRenderer/IncludeRegardlessOfValuesCellRenderer';
import VwTapGrid from './VwTapGrid';

import DownloadFileMixin from '@/mixins/DownloadFileMixin';

export default {
  name: "Dashboard-tap",
  mixins: [DownloadFileMixin],
  components: {
    AgGridVue,
    currencyCellRenderer: CurrencyCellRenderer,
    percentageCellRenderer: PercentageCellRenderer,
    ExportPopup,
    DetailColumnToolPanel,
    includeRegardlessOfValuesCellRenderer: IncludeRegardlessOfValuesCellRenderer,
    VwTapGrid
  },
  data() {
    return {
      filter: {
        survey: null,
        scenario: null,
        wave: null,
        customProp: null,
        statusFrom: null,
        statusTo: null,
        getNet: false,
        reportType: null,
        premiumToVolumen: false,
      },
      treeselect: {
        structureItems: [],
        scenario: [],
        wave: [],
        customProp: [],
      },
      isLoading: false,

      grouped: {
        columnDefs: null,
        detailCellRendererParams: null,
        // gridApi: null,
        // gridColumnApi: null,
        masterDetail: true,
        rowData: [],
        sideBar: {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: this.$t('Webportal.VwTap.SidebarToolPanelLabelGrouped'),
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
              toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressColumnFilter: false,
                suppressColumnSelectAll: false,
                suppressColumnExpandAll: false,
              },
            },
            {
              id: 'detailColumns',
              labelDefault: this.$t('Webportal.VwTap.SidebarToolPanelLabelSingleCheck'),
              labelKey: 'detailColumns',
              iconKey: 'columns',
              toolPanel: 'DetailColumnToolPanel',
            },
            {
              id: 'filters',
              labelDefault: this.$t('Webportal.VwTap.Filter'),
              labelKey: 'filters',
              iconKey: 'filter',
              toolPanel: 'agFiltersToolPanel',
              toolPanelParams: {
                suppressExpandAll: false,
                suppressFilterSearch: false,
              },
            },
          ],
        },
        showLoadingOverlay: false,
      },
      singleCheck: {
        columnDefs: null,
        detailCellRendererParams: null,
        // gridApi: null,
        // gridColumnApi: null,
        masterDetail: false,
        rowData: [],
        sideBar: {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: this.$t('Webportal.VwTap.SidebarToolPanelLabel'),
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
              toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressColumnFilter: false,
                suppressColumnSelectAll: false,
                suppressColumnExpandAll: false,
              },
            },
            {
              id: 'filters',
              labelDefault: this.$t('Webportal.VwTap.Filter'),
              labelKey: 'filters',
              iconKey: 'filter',
              toolPanel: 'agFiltersToolPanel',
              toolPanelParams: {
                suppressExpandAll: false,
                suppressFilterSearch: false,
              },
            },
          ],
        },
        showLoadingOverlay: false,
        rowClassRules: {
          // apply green to
          'rcr-green-row': params => { return (
            params.data.StandardDeviationTooBig === false &&
            params.data.ConfigurationDeviationTooBig === false
          ); },
          // apply light green to
          'rcr-light-green-row': params => { return (
            (params.data.StandardDeviationTooBig === true || params.data.ConfigurationDeviationTooBig === true ) &&
            params.data.IncludeRegardlessOfValues === true
          ); },
          // apply red to
          'rcr-red-row': params => { return (
            (params.data.StandardDeviationTooBig === true ||
            params.data.ConfigurationDeviationTooBig === true ) &&
            params.data.IncludeRegardlessOfValues === false
          ); },
        },
      },
      exportGrid: {
        columnDefs: null,
        detailCellRendererParams: null,
        gridApi: null,
        gridColumnApi: null,
        masterDetail: true,
        rowData: [],
      },

      showExportPopup: false,
      // firstRowSurveyInstances: null,
      displayGrid: 'grouped',
    }
  },
  watch: {
    '$i18n.global.locale': function() {this.loadLocalization()}
  },
  created() {
    this.getSurveyStructure();

    EventBus.$on('getSheetDataForExcel', (sheetData, level) => {
      switch (level) {
        case 'grouped':
          this.grouped.sheetData = sheetData;
          break;
        case 'single':
          this.singleCheck.sheetData = sheetData;
          break;
        default:
          break;
      }
    })
  },
  beforeMount() {
    this.grouped.detailCellRendererParams = {
      // level 2 grid options
      detailGridOptions: {
        columnDefs: null,
        suppressPropertyNamesCheck: true,
        enableRangeSelection: true,
        rowClassRules: {
          // apply green to
          'rcr-green-row': params => { return (
            params.data.StandardDeviationTooBig === false &&
            params.data.ConfigurationDeviationTooBig === false
          ); },
          // apply light green to
          'rcr-light-green-row': params => { return (
            (params.data.StandardDeviationTooBig === true || params.data.ConfigurationDeviationTooBig === true ) &&
            params.data.IncludeRegardlessOfValues === true
          ); },
          // apply red to
          'rcr-red-row': params => { return (
            (params.data.StandardDeviationTooBig === true ||
            params.data.ConfigurationDeviationTooBig === true ) &&
            params.data.IncludeRegardlessOfValues === false
          ); },
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.SurveyInstances);
      },
    };
    this.exportGrid.detailCellRendererParams = {
      // level 2 grid options
      detailGridOptions: {
        columnDefs: null,
        suppressPropertyNamesCheck: true,
        rowSelection: 'single',
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.SurveyInstances);
      },
    };
    this.loadColumnDefs();
  },
  methods: {
    // Get survey structure data for the structure treeselect
    getSurveyStructure() {
      this.isLoading = true;
      SurveysService.getSurveyStructure()
      .then(response => {
        this.treeselect.structureItems = response.data;
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    loadFilterData() {
      const filter = {surveyIds: [this.filter.survey.Survey.SurveyId]};
      this.getSurveyWaves(filter);
      this.getSurveyScenarios(filter);
      this.getSurveyCustomProperties(filter);
    },
    getSurveyWaves(filter) {
      this.treeselect.wave = [];
      SurveysService.getSurveyWaves(filter)
      .then(response => {
        this.treeselect.wave = response.data;
      })
    },
    getSurveyScenarios(filter) {
      this.treeselect.scenario = [];
      SurveysService.getSurveyScenarios(filter)
      .then(response => {
        this.treeselect.scenario = response.data;
      })
    },
    getSurveyCustomProperties(filter) {
      this.treeselect.customProp = [];
      SurveysService.getSurveyCustomProperties(filter, true)
      .then(response => {
        this.treeselect.customProp = response.data;
      })
    },
    async loadColumnDefs() {
      var colDefsLevel1 = await this.getGridColumnDefinitions(1);
      colDefsLevel1.forEach(colDef => {
        colDef.headerName = this.$t(colDef.mdsEntry);
      });
      var colDefsLevel2 = await this.getGridColumnDefinitions(2);
      colDefsLevel2.forEach(colDef => {
        colDef.headerName = this.$t(colDef.mdsEntry);
      });
      this.grouped.columnDefs = colDefsLevel1;
      this.grouped.detailCellRendererParams.detailGridOptions.columnDefs = colDefsLevel2;
      this.singleCheck.columnDefs = colDefsLevel2;
      this.exportGrid.columnDefs = colDefsLevel1;
      this.exportGrid.detailCellRendererParams.detailGridOptions.columnDefs = colDefsLevel2;
    },
    async getGridColumnDefinitions(level) {
      return VwTapService.getGridColumnDefinitions(level)
      .then(response => {
        return response.data;
      })
    },
    loadRowData() {
      this.loadColumnDefs();

      this.grouped.showLoadingOverlay = true;
      this.singleCheck.showLoadingOverlay = true;
      VwTapService.getSurveyInstanceData(this.filter)
      .then(response => {
        this.grouped.rowData = response.data?.GroupedExport ? response.data.GroupedExport : [];
        this.singleCheck.rowData = response.data?.SingleCheckFinal ? response.data.SingleCheckFinal : [];

        this.prepareExportGridColumnData(response.data);

        setTimeout(() => {
          EventBus.$emit('MountGridData');
        }, 200);
      })
      .finally(() => {
        this.grouped.showLoadingOverlay = false;
        this.singleCheck.showLoadingOverlay = false;
      })
    },
    prepareExportGridColumnData(data) {
      // if no data is available, create an array/object with the same structure ("[{SurveyInstances: []}]"),
      // so that an export with both sheets is still possible, but empty.
      var rowData = null;
      if (data.GroupedExport) {
        rowData = JSON.parse(JSON.stringify(data.GroupedExport));
        rowData.forEach(e => {
          e.SurveyInstances = null;
        });
      } else {
        rowData = [{}];
      };
      rowData[0].SurveyInstances = data.SingleCheckFinal ? data.SingleCheckFinal : [];
      this.exportGrid.rowData = rowData;
    },
    onExportGridReady(params) {
      this.exportGrid.gridApi = params.api;
      this.exportGrid.gridColumnApi = params.columnApi;
    },
    loadLocalization() {
      // column headers
      this.grouped.columnDefs.forEach(colDef => {
        colDef.headerName = this.$t(colDef.mdsEntry);
      });
      this.grouped.detailCellRendererParams.detailGridOptions.columnDefs.forEach(colDef => {
        colDef.headerName = this.$t(colDef.mdsEntry);
      });
      this.singleCheck.columnDefs.forEach(colDef => {
        colDef.headerName = this.$t(colDef.mdsEntry);
      });
      this.exportGrid.columnDefs.forEach(colDef => {
        colDef.headerName = this.$t(colDef.mdsEntry);
      });
      this.exportGrid.detailCellRendererParams.detailGridOptions.columnDefs.forEach(colDef => {
        colDef.headerName = this.$t(colDef.mdsEntry);
      });

      this.exportGrid.gridApi.setColumnDefs(this.exportGrid.columnDefs);
      this.exportGrid.gridApi.forEachDetailGridInfo((detailGridApi) => {
        if(detailGridApi) detailGridApi.gridApi?.setColumnDefs(this.exportGrid.detailCellRendererParams.detailGridOptions.columnDefs);
      });

      EventBus.$emit('LoadDetailColumnToolPanelLocalization'); //event for DetailColumnToolPanel.vue
      EventBus.$emit('MountGridData'); //event for VwTapGrid.vue
    },

    // EXPORT:
    exportExcelFile() {
      // expand the first row and collapse all others
      this.exportGrid.gridApi.forEachNode(function (node) {
        if(node.rowIndex === 0) {
          node.expanded = true;
        }
        else {
          node.expanded = false;
        }
      });
      this.exportGrid.gridApi.onGroupExpandedOrCollapsed();

      var colIds = [];
      this.exportGrid.gridColumnApi.getColumns().forEach(col => {
        if(col.colDef?.excludeFromExport === false) {
          colIds.push(col.getId());
        }
      });

      var spreadsheets = [];
      const mainSheet = this.exportGrid.gridApi.getSheetDataForExcel({
        columnKeys: colIds,
        sheetName: this.$t('Webportal.VwTap.GroupedView'),
      });
      if (mainSheet) {
        spreadsheets.push(mainSheet);
      }
      this.exportGrid.gridApi.forEachDetailGridInfo(node => {
        var detailColIds = [];
        node.columnApi.getColumns().forEach(col => {
          if(col.colDef?.excludeFromExport === false) {
            detailColIds.push(col.getId());
          }
        });
        const sheet = node.api.getSheetDataForExcel({
          columnKeys: detailColIds,
          sheetName: this.$t('Webportal.VwTap.SingleCheckView'),
        });
        if (sheet) {
          spreadsheets.push(sheet);
        }
      });

      const date = new Date(Date.now())
      const dateISOString = date.toISOString()
      this.exportGrid.gridApi.exportMultipleSheetsAsExcel({
        data: spreadsheets,
        fileName: 'vw-tap' + dateISOString + '.xlsx',
        author: 'MSM Loop'
      });

      this.closeExportPopup();
    },
    openExportPopup() {
      this.showExportPopup = true;
    },
    closeExportPopup() {
      this.showExportPopup = false;
    },
    swapGrid() {
      if(this.displayGrid === 'grouped') {
        this.displayGrid = 'single';
      } else {
        this.displayGrid = 'grouped';
      }
      setTimeout(() => {
        EventBus.$emit('autoSizeColumns');
      }, 50);
    },

    // REPORT:
    exportExcelReport() {
      // Set spinning cursor
      document.body.style.cursor = "progress";

      VwTapService.getReport(this.filter)
      .then(response => {
        this.downloadFile(response)
      })
      .catch(error => console.warn(error))
      .finally(() => {
        document.body.style.cursor = null;
      });
    },
    exportExcelFsReport() {
      // Set spinning cursor
      document.body.style.cursor = "progress";

      VwTapService.getFsReport(this.filter)
      .then(response => {
        this.downloadFile(response)
      })
      .catch(error => console.warn(error))
      .finally(() => {
        document.body.style.cursor = null;
      });
    },
    exportExcelRawData() {
      // Set spinning cursor
      document.body.style.cursor = "progress";

      VwTapService.getRawData(this.filter)
      .then(response => {
        this.downloadFile(response)
      })
      .catch(error => console.warn(error))
      .finally(() => {
        document.body.style.cursor = null;
      });
    }
  },
}
</script>

<style lang="scss">
  .rcr-green-row {
    background-color: rgb(154, 204, 154) !important;
  }
  .rcr-red-row {
    background-color: rgb(196, 142, 142) !important;
  }
  .rcr-light-green-row {
    background-color: rgb(187, 241, 187) !important;
  }
</style>
